<template>
  <div class="userinfoshow">
    <user-title :msg="msg" />
    <div class="usercontents">

      <div class="usercontents-line">
        <div class="left">手机</div>
        <div class="midd notFindMidd" v-if="!UserPhone" @click="showRelation(1)">绑定手机号</div>
        <div class="midd" v-else>{{UserPhone}}</div>
        <div class="right" v-show="UserPhone">已绑定</div>
      </div>

      <div class="usercontents-line">
        <div class="left">邮箱</div>
        <div class="midd notFindMidd" v-if="!UserMail" @click="showRelation(2)">绑定邮箱</div>
        <div class="midd" v-else>{{UserMail}}</div>
        <div class="right" v-show="UserMail">已绑定</div>
      </div>

    </div>
    <popup :isShow="isShow" :type="showType" :isShow.sync="isShow"></popup>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import UserTitle from "./UserTitle.vue";
import Popup from "./Popup.vue";
export default {
  data() {
    return {
      msg: "绑定账号",
      isShow:false,
      showType:1
    };
  },
  components: { UserTitle, Popup },
  methods: {
    showRelation(val){
      this.isShow = true;
      this.showType = val;
    }
  },
  computed: {
    ...mapGetters(['UserMail','UserPhone'])
  }
};
</script>

<style scoped>
.usercontents-line{
  overflow: hidden;
  margin-top: 38px;
  height: 30px;
  line-height: 30px;
}
.usercontents-line .left,.usercontents-line .midd,.usercontents-line .right{
  float: left;
}
.usercontents-line .left,.usercontents-line .right{
  font-size: 18px;
  color: #333333;
  margin-right: 45px;
}
.usercontents-line .right{
  margin-left: 20px;
}
.usercontents-line .midd{
  font-size: 16px;
  color: #999999;

}
.usercontents-line .notFindMidd{
  color: #fff;
  background-color: #2655ae;
  padding: 0 12px;
  border-radius: 5px;
  cursor:pointer;
}

</style>


// WEBPACK FOOTER //
// src/components/user/UserRelation.vue